<div class="px-2 px-md-2 px-lg-4 py-2 py-md-2 py-lg-4 h-100 position-fixed">
    <div (click)="moveToLandingPage()" style="display: flex; justify-content:center; height:auto; cursor:pointer;">
        <img src="../../../../assets/images/logo.png" alt="LOGO">
    </div>

    <div style="margin-top: 40px; height:60%;">
        <div *ngFor="let menu of menuList; let index=index;" [id]="index" class="menuContainer" [class.clickedClasss]="menuIsActive(index)"
            (click)="menuClick(menu.text, index)">
            <!-- Icons -->
            <svg *ngIf="menu.text == 'Dashboard'" id="Group_16603" data-name="Group 16603"
                xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                <path id="Path_6345" data-name="Path 6345" d="M0,0H24V24H0Z" fill="none" />
                <path id="Path_6346" data-name="Path 6346" d="M3,13h8V3H3Zm0,8h8V15H3Zm10,0h8V11H13ZM13,3V9h8V3Z"
                    fill="#3e3e3e" />
            </svg>

            <svg *ngIf="menu.text == 'Facility Listing'" xmlns="http://www.w3.org/2000/svg" width="21" height="21"
                viewBox="0 0 18 20">
                <path id="Path_6967" data-name="Path 6967"
                    d="M21,9V20.993A1,1,0,0,1,20.007,22H3.993A.993.993,0,0,1,3,21.008V2.992A1,1,0,0,1,4,2H14V8a1,1,0,0,0,1,1Zm0-2H16V2ZM8,7V9h3V7Zm0,4v2h8V11Zm0,4v2h8V15Z"
                    transform="translate(-3 -2)" fill="#3e3e3e" />
            </svg>

            <svg *ngIf="menu.text == 'CSE Section'" id="Group_16677" data-name="Group 16677"
                xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                <path id="Path_6534" data-name="Path 6534" d="M0,0H24V24H0Z" fill="none" />
                <path id="Path_6535" data-name="Path 6535"
                    d="M21,20h2v2H1V20H3V3A1,1,0,0,1,4,2H20a1,1,0,0,1,1,1ZM11,8H9v2h2v2h2V10h2V8H13V6H11Zm3,12h2V14H8v6h2V16h4Z"
                    fill="#3e3e3e" />
            </svg>

            <svg *ngIf="menu.text == 'Reports'" xmlns="http://www.w3.org/2000/svg" width="21" height="21"
                viewBox="0 0 18 20">
                <path id="Path_6968" data-name="Path 6968"
                    d="M20,22H4a1,1,0,0,1-1-1V3A1,1,0,0,1,4,2H20a1,1,0,0,1,1,1V21A1,1,0,0,1,20,22ZM8,7V9h8V7Zm0,4v2h8V11Zm0,4v2h8V15Z"
                    transform="translate(-3 -2)" fill="#3e3e3e" />
            </svg>

            <!-- Text -->
            <span style="margin-left: 10px; font-size:16px; font-weight:600;">
                {{menu.text}}
            </span>

            <!-- Arrow Down -->
            <i *ngIf="menu.text == 'CSE Section' && showCSEMenu" class="fa fa-caret-up"
                style="margin-left:auto; font-size: 20px; margin-right:10px;" aria-hidden="true"></i>

            <i *ngIf="menu.text == 'CSE Section' && !showCSEMenu" class="fa fa-caret-down"
                style="margin-left:auto; font-size: 20px; margin-right:10px;" aria-hidden="true"></i>
        </div>

        <div *ngIf="showCSEMenu" class="cseSectionMenu">
            <li (click)="showCSESEMenu('menu1')">CSE Master Listing</li>
            <li (click)="showCSESEMenu('menu2')" style="margin-top: 15px;">Facility CSE</li>
            <div (click)="showCSESEMenu('menu2')" style="margin-left: 20px;">Mapping Listing</div>
        </div>

        <!-- <div class="menuContainer" (click)="logoutClick()">
            <svg id="Group_16557" data-name="Group 16557" xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                viewBox="0 0 24 24">
                <path id="Path_6204" data-name="Path 6204" d="M0,0H24V24H0Z" fill="none" />
                <path id="Path_6205" data-name="Path 6205"
                    d="M4,18H6v2H18V4H6V6H4V3A1,1,0,0,1,5,2H19a1,1,0,0,1,1,1V21a1,1,0,0,1-1,1H5a1,1,0,0,1-1-1Zm2-7h7v2H6v3L1,12,6,8Z"
                    fill="#3e3e3e" />
            </svg>
            <span style="margin-left: 10px; font-size:16px; font-weight:600;">Logout</span>
        </div> -->
    </div>

    <div style="height:30%; display:flex; padding-bottom:10px; align-items:end;">
        <div class="avatarContainer">
            <div (click)="avatarClick()" class="p-2 avatarAdminContainer">
                <!-- <div class="userIconContainer">
                <i class="fa fa-user" style="color: rgb(231,236,237); font-size:18px" aria-hidden="true"></i>
            </div> -->
                <!-- <svg xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 20 20" height="36px" viewBox="0 0 20 20" width="36px" fill="#000000"><g><rect fill="none" height="20" width="20"/></g><g><g><path d="M10 5.5c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3zm0 4.5c-.83 0-1.5-.67-1.5-1.5S9.17 7 10 7s1.5.67 1.5 1.5S10.83 10 10 10z"/><path d="M10 2c-4.42 0-8 3.58-8 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8zm0 14.5c-1.49 0-2.86-.51-3.96-1.36C7.19 14.42 8.55 14 10 14s2.81.42 3.96 1.14c-1.1.85-2.47 1.36-3.96 1.36zm5.07-2.44c-1.44-.99-3.19-1.56-5.07-1.56s-3.62.58-5.07 1.56C4.04 12.95 3.5 11.54 3.5 10c0-3.58 2.92-6.5 6.5-6.5s6.5 2.92 6.5 6.5c0 1.54-.54 2.95-1.43 4.06z"/></g></g></svg> -->

                <div class="nav-item p-2 userIconContainer">
                    <i class="fa fa-user" style="color: rgb(231,236,237); font-size:18px" aria-hidden="true"></i>
                </div>
                <div class="avatar-text ps-md-2 ps-lg-3">
                    <div style="font-weight: 600;">{{roleName}}</div>
                    <!-- <div>{{roleName}}</div> -->
                </div>
                <div style="margin-left: auto;">
                    <i *ngIf="!profileOpen" class="fa fa-caret-up" style="font-size: 20px; cursor:pointer;"
                        aria-hidden="true"></i>
                    <i *ngIf="profileOpen" class="fa fa-caret-down" style="font-size: 20px; cursor:pointer;"
                        aria-hidden="true"></i>
                </div>
            </div>

            <div *ngIf="showLogout" class="logoutContainer" (click)="logoutClick()">
                <svg id="Group_16557" data-name="Group 16557" xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                    viewBox="0 0 24 24">
                    <path id="Path_6204" data-name="Path 6204" d="M0,0H24V24H0Z" fill="none" />
                    <path id="Path_6205" data-name="Path 6205"
                        d="M4,18H6v2H18V4H6V6H4V3A1,1,0,0,1,5,2H19a1,1,0,0,1,1,1V21a1,1,0,0,1-1,1H5a1,1,0,0,1-1-1Zm2-7h7v2H6v3L1,12,6,8Z"
                        fill="#3e3e3e" />
                </svg>
                <span style="margin-left: 15px; font-size:16px; font-weight:600;">Logout</span>
            </div>
        </div>
    </div>
</div>